export enum EmailTypeKey {
  single = "email-address-priority",
  batch = "email-address-batch-priority",
}

export enum EmailTypeValue {
  gmail_alias = "gmail_alias",
  gmail_primary = "gmail_primary",
  user_account_email = "primary",
  lendflow_alias = "alias",
  system_email = "whitelabel",
}

export enum PhoneNumberPreferences {
  routing = "phone-number-routing",
  provider = "call-provider",
}

export enum AudioDevicePreferences {
  input = "audio-input-device",
  output = "audio-output-device",
}
